import { Card, Flex, Subtitle, Text, Title } from '@tremor/react';
import s from './SubscriptionCard.module.scss';
import { SubscriptionButton } from '@/components/layouts/Buttons/SubscriptionButton/SubscriptionButton';
import { RiCheckLine } from '@remixicon/react';
import classNames from 'classnames';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { NAV_ROUTES } from '@/utils/constants';
import { PopupModal } from 'react-calendly';
import { useState } from 'react';
import { StripeSubscription } from '@/types/Stripe';

interface Props {
  name: string;
  description: string;
  price: number;
  currency: string;
  mode: string;
  organizationId: string;
  priceId: string;
  features?: StripeSubscription['marketing_features'];
  isMostBought?: boolean;
  isNotSub?: boolean;
}

export function SubscriptionCard({
  description,
  name,
  price,
  priceId,
  features,
  isMostBought,
  isNotSub,
}: Props) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Card className={classNames(s.card, { [s.popularCard]: isMostBought })}>
        {isMostBought ? (
          <div className={s.mostPopularContainer}>
            <Text className={s.mostPopularText}>Most Popular</Text>
          </div>
        ) : null}
        <Flex flexDirection="col" alignItems="start">
          <Title className={s.subtitle}>{name}</Title>
          <Subtitle className={s.description}>{description}</Subtitle>
          <Text className={s.price}>
            {price ? `$${(price / 100).toFixed(2)}` : 'Custom Price'}
            {price ? <span className={s.period}>/Month</span> : null}
          </Text>
          <SubscriptionButton
            className={classNames(s.subscribeButton, { [s.popularButton]: isMostBought })}
            onClick={async () => {
              if (price) {
                const params = new URLSearchParams(searchParams.toString());
                params.set('priceId', priceId);
                navigate(`${NAV_ROUTES.subscriptions}?${params.toString()}`);
              } else {
                setIsOpen(true);
              }
            }}
          >
            {isNotSub ? 'Get a Demo' : 'Get Started'}
          </SubscriptionButton>
          {features ? <FeatureList features={features} /> : null}
        </Flex>
      </Card>
      <PopupModal
        url="https://calendly.com/defuseddata-maciek/marchemy-demo"
        onModalClose={() => setIsOpen(false)}
        open={isOpen}
        rootElement={document.getElementById('root') as HTMLElement}
      />
    </>
  );
}

interface FeatureListProps {
  features: StripeSubscription['marketing_features'];
}

export function FeatureList({ features }: FeatureListProps) {
  return (
    <ul className={s.featuresContainer}>
      {features.map((val) => (
        <li key={val.name} className={s.li}>
          <Flex justifyContent="start" className="gap-2">
            <RiCheckLine className={s.checkmark} />
            <Text className={s.featureText}>{val.name}</Text>
          </Flex>
        </li>
      ))}
    </ul>
  );
}
